import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { groupBy } from '@helpers/utilities';
import { LmsApi } from '@services/_api/lms-api';

@Component({
  selector: 'app-account-selector',
  templateUrl: './account-selector.component.html',
  styleUrls: ['./account-selector.component.css'],
})
export class AccountSelectorComponent {
  public accountsGroupedByTenant: {
    tenantName: string;
    accounts: LmsApi.AuthenticateResponse[];
  }[] = [];

  constructor(
    @Inject(MAT_DIALOG_DATA) private potentialAccounts: LmsApi.AuthenticateResponse[],
    private dialogRef: MatDialogRef<AccountSelectorComponent, LmsApi.AuthenticateResponse>
  ) {
    this.parsePotentialAccounts(this.potentialAccounts);
  }

  public selectAccount(account: LmsApi.AuthenticateResponse) {
    this.dialogRef.close(account);
  }

  public useAnotherAccount() {
    this.dialogRef.close();
  }

  private parsePotentialAccounts(potentialAccounts: LmsApi.AuthenticateResponse[]) {
    const accountsGroupedByTenant = groupBy(
      potentialAccounts,
      (x) => x.tenant.name
    );

    const distinctTenants = Object.keys(accountsGroupedByTenant).sort();

    this.accountsGroupedByTenant = distinctTenants.map((tenantName: string) => {
      const accounts = accountsGroupedByTenant[tenantName];
      return { tenantName, accounts };
    });
  }
}
